import React, { useEffect, useRef } from "react";
import PropTypes from "prop-types";
import classNames from "classnames";
import { connect } from "react-redux";
import get from "lodash/get";

import {
  toggleSubmitGroupSelectAll,
} from "../../actions/historyActions";

import {
  submitEntryGroup,
} from "../../actions/entryActions";

import confirmWith from "../../utils/confirm-with";

export function BottomControls({ hidden, selectAllDisabled, selectAllState, submitDisabled, submitEntryGroup, toggleSelectAll }) {
  const selectAllRef = useRef();

  useEffect(function() {
    if (!selectAllRef.current) {
      return;
    }

    selectAllRef.current.checked = selectAllState === "checked";
    selectAllRef.current.indeterminate = selectAllState === "indeterminate"
  }, [selectAllState]);

  if (hidden) {
    return null;
  }

  const buttonClasses = classNames({
    "btn-submit": !submitDisabled,
    "btn-mgtt": Boolean(submitDisabled),
  });

  return (
    <div className="bottom-controls">
      <fieldset
        className="pull-left select-all"
        disabled={selectAllDisabled}
      >
        <label>
          <input
            type="checkbox"
            ref={selectAllRef}
            value={selectAllState}
            onClick={toggleSelectAll}
          />&nbsp;Select all
        </label>
      </fieldset>
      <div className="pull-right">
        <button
          className={buttonClasses}
          onClick={submitEntryGroup}
          disabled={submitDisabled}
        >Submit</button>
      </div>
    </div>
  );
}

BottomControls.displayName = "History.List.BottomControls";

BottomControls.propTypes = {
  hidden: PropTypes.bool.isRequired,
  selectAllDisabled: PropTypes.oneOfType([
    PropTypes.string,
    PropTypes.bool
  ]).isRequired,
  selectAllState: PropTypes.oneOf(["none", "indeterminate", "checked"]).isRequired,
  submitDisabled: PropTypes.oneOfType([
    PropTypes.string,
    PropTypes.bool
  ]).isRequired,
  submitEntryGroup: PropTypes.func.isRequired,
  toggleSelectAll: PropTypes.func.isRequired,
  version: PropTypes.string.isRequired,
};

BottomControls.defaultProps = {
  hidden: true,
  submitDisabled: "disabled",
  version: "version-null",
};

function mapStateToProps(state) {
  const historyContext =  state.historyFilters.context;
  const loading = state.entry.deleteProcessing || state.entry.submitProcessing || state.entries.entriesInTransit;
  const { entries, submitGroup, version } = state.entries;

  const props = {
    hidden: entries.length === 0 || loading,
    submitDisabled: "disabled",
    selectAllDisabled: "disabled",
    selectAllState: "none",
    version
  };

  if (historyContext === "submitted") {
    return props;
  }

  let checkedCount = 0;
  let submittableCount = 0;

  for (const entry of entries) {
    if (submitGroup[entry.id]) {
      props.submitDisabled = false;

      ++checkedCount;
    }

    if (entry.hours > 0 && !entry.submitted) {
      props.selectAllDisabled = false;

      ++submittableCount;
    }
  }

  if (checkedCount > 0) {
    props.selectAllState = checkedCount === submittableCount ? "checked" : "indeterminate";
  }

  return props;
}

function mapDispatchToProps(dispatch) {
  return {
    async submitEntryGroup() {
      return await confirmWith("Are you sure you want to submit all selected entries?", async function() {
        await dispatch(submitEntryGroup());
      });
    },
    toggleSelectAll(event) {
      const enabled = Boolean(get(event, "target.checked"));

      return dispatch(toggleSubmitGroupSelectAll(enabled));
    },
  };
}

export default connect(mapStateToProps, mapDispatchToProps)(BottomControls);



// WEBPACK FOOTER //
// ./app/components/History/BottomControls.jsx